var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.vista)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"anterior"},[_c('arrow-left')],1),_c('div',{staticClass:"adelante"},[_c('sales-button',{staticClass:"button",attrs:{"label":_vm.nombreSiguiente,"loading":_vm.disabled,"analyticsName":_vm.analyticsName},on:{"click":_vm.adelante}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }